<template>
  <div>
    <div v-html="pMsg" />
  </div>
</template>

<script>
export default {
  name: 'Dot',
  props: {
    line: { type: Number, default: 3 },
    msg: { type: String, required: true },
  },
  data() {
    return {
      pMsg: this.msg,
      isDot: false,
    };
  },
  mounted() {
    this.dot();
  },
  methods: {
    /*
      Truncating message so it fits into desired line
    */
    dot() {
      const dom = this.$el.querySelector('div');

      // Get div height (height of current div with complete message)
      let height = parseInt(window.getComputedStyle(dom).height, 10);

      // Get div line height (height of 1 line)
      const lineHeight = parseInt(window.getComputedStyle(dom)['line-height'], 10);

      // Substring message until content height less than number of specified line * 3
      // 3 for safety measure so didn't truncate too much
      while (height > lineHeight * this.line * 3) {
        this.isDot = true;
        this.pMsg = this.pMsg.substring(0, this.pMsg.length / 2);
        dom.innerHTML = this.pMsg;
        height = parseInt(window.getComputedStyle(dom).height, 10);
      }

      // replace message last character with '...' until content height less than specified line
      // regex: (space, newline, and tab) if any + last character + '...' if any
      while (height > lineHeight * this.line) {
        this.isDot = true;
        this.pMsg = this.pMsg.replace(/(\s)*([a-zA-Z0-9]+|\W)(\.\.\.)?$/, '...');
        dom.innerHTML = this.pMsg;
        height = parseInt(window.getComputedStyle(dom).height, 10);
      }

      if (this.isDot) {
        this.$emit('isDot');
      }
    },
  },
};
</script>
